
import {  GetCountries, GetHotListByID, UpdateHotList } from "../apiconstants/constants";
import { useState, useEffect } from 'react';
import Axios from "axios";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from "sweetalert2";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link, useLocation,useNavigate} from "react-router-dom";
import { useCountry } from "../contexts/countrycodecontext.js";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const EditHotList = () => {
  let query = useQuery();
  const HotListID = query.get("HotListID");
  const guid = localStorage.getItem("guid");
  const navigate=useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  var apiUrl = {};
  const { register, handleSubmit, setValue, formState,reset } = useForm();
  const { errors } = formState
  const { isSubmitting } = formState;
  const[HLID,setHLID] = useState();
  const [Countries,SetCountries]=useState([{}]);
  const [type, settype] = useState([
    {statusID:"1",statusName:"Recruiter"},
    {statusID:"2",statusName:"BenchSales"}])
    const { selectedCountry} = useCountry();
const [tier,setTier] = useState([
    {tierID:"Tier 1",tierName:"Tier 1"},
    {tierID:"Tier 2",tierName:"Tier 2"},
    {tierID:"Tier 3",tierName:"Tier 3"},
])
const GetVendorDetailsById = () => {
  const GetapiUrl = `${GetHotListByID.APIURL}?HotListID=${HotListID}`;

  Axios.get(GetapiUrl,
    { headers: {
      Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
      "Content-Type": "application/json",
    }
  }
  )
    .then((result) => {
      setValue("name",result.data[0].name)
      setValue("emailId",result.data[0].emailId)
      setValue("phone",result.data[0].phone)
      setValue("company",result.data[0].company)
      setValue("website",result.data[0].website)
      setValue("country",result.data[0].country)      
      console.log(typeof result.data[0].country)
      setValue("type",result.data[0].type)
      setValue("tierType",result.data[0].tierType)
      setValue("description",result.data[0].description)
      setHLID(result.data[0].hotListID)

    })
  }
  const onSubmit = (data, e) => {
    e.preventDefault();
    updateData(data);
  return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });
  }
  const email = localStorage.getItem("email")
const token = localStorage.getItem("jwtToken");
  const updateData = async(data) => {
    const params={
      "hotListID":HLID,
      "name": data.name,
      "emailId": data.emailId,
   "phone":data.phone,
   "company": data.company,
   "website":data.website,
   "description": data.description,
   "type" : data.type,
     "userGuid": guid,
     "tierType":data.tierType||'Tier 2',
   "updatedBy": email,
   "countryID": Number(selectedCountry)
 }
 apiUrl = UpdateHotList.APIURL;
 Axios.put(apiUrl, params,
    { headers: {  
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    }
  }
 )
   .then((result) => {
          if (result.data === "Updated successfully") {
       // GetConsultantProfile();
     Swal.fire({
         position: 'center',
         icon: 'success',
         title: 'Updated Successfully ',
         showConfirmButton: false,
         timer: 5000
       })
       // toast.success('Data Saving', {autoClose:5000})
       navigate("/Employer/ListofStaffingContacts")

     }
    else if(result.data== 'Duplicate EmailId exists for this UserGuid.'){
       // toast.error('Issue with data format', {autoClose:5000})
       Swal.fire({
         position: 'center',
         icon: 'error',
         title: 'Duplicate EmailId exists!',
         showConfirmButton: false,
         timer: 5000
       })
     } else {
       // toast.error('Issue with data format', {autoClose:5000})
       Swal.fire({
         position: 'center',
         icon: 'error',
         title: 'Add correct Details',
         showConfirmButton: false,
         timer: 5000
       })
     }

   }).catch(
     function (error) {
       console.log("Error" + error)
     })

}
const fetchcountries=()=>
  {
    const GetapiUrl=GetCountries.APIURL;
    const fetchJSON = async () => {
      const response = await fetch(GetapiUrl,
        { headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",         
        }
      }
      );
      let json = await response.json();
      SetCountries(json);
    }
    fetchJSON();
}


  useEffect(() => {
    fetchcountries();
    GetVendorDetailsById();
   

  }, []);

  return (
    <ConsultantLayout>
      <section>
        <div className="container-fluid mt-4 pb-5">
          <div className='row'>
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6  mt-3'>
           <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/ListofStaffingContacts">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Edit Staffing Contact</h2>
</div>      </div>
     </div>
<hr/>
<div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
<form onSubmit={handleSubmit(onSubmit)} >
<div className="row mt-2 p-0">
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
         
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Name</Tooltip>)}>
                <input type="text" name="name"  {...register("name", { required: "Name Required" })} placeholder="Name" className={`form-control basic-form  ${errors.name ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.name?.message}</div>
            <div className="mt-4">      
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>  Email</Tooltip>)}>
                <input type="email"  name="emailId" {...register("emailId")}  placeholder="Email" className={`form-control basic-form`} />
              </OverlayTrigger>
              {/* <div className="invalid-feedback">{errors.email?.message}</div> */}
              <div className="mt-4">
                              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Website URL</Tooltip>)}>
                <input type="text" name="website" {...register("website")} placeholder="Website URL" className={`form-control basic-form`}/>
              </OverlayTrigger>


               <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Tier Type</Tooltip>)}>    

<select  {...register("tierType", )} className={`form-control basic-form mt-3 `} style={{height:50,borderRadius:15}}  >
<option value="">Select Tier </option>
{
tier.map((item,index)=>
{
return(

<option key={index}  value={item.tierName}>{item.tierName}</option>

);
}

)
}
</select>
</OverlayTrigger>

        </div>
        <div className="mt-4">
                              {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Website URL</Tooltip>)}>
                <input type="text" name="website" {...register("website")} placeholder="Website URL" className={`form-control basic-form`}/>
              </OverlayTrigger> */}
              {/* <div className="invalid-feedback">{errors.websiteURL?.message}</div> */}

        </div>
         </div>
         <div className="mt-4"> 
      </div>
            </div>
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>

                <input
                  placeholder='Mobile Number'
                  type="text"
                  min="0"
                  title=''
                  name="phone"
                  disabled={isDisabled}
                  {...register("phone" , { required: "Mobile Number Required" })}
                  className={`form-control basic-form ${errors.phone ? 'is-invalid' : ''}`}

                />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.phone?.message}</div>

             
              <div className="mt-4"> 
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Company Name</Tooltip>)}>
                <input type="text" title="" name="company" {...register("company")} placeholder="Company Name" className={`form-control basic-form`} />
              </OverlayTrigger>
              {/* <div className="invalid-feedback">{errors.domain?.message}</div> */}
              <div className="mt-4">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Description</Tooltip>)}>
                <textarea type="text" title="" name="description" {...register("description")} placeholder="Description" className={`form-control basic-form`} />
              </OverlayTrigger>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Type</Tooltip>)}>

<select  {...register("type", { required: "Type Required" })} className={`form-control basic-form mt-3 ${errors.type ? 'is-invalid' : ''}`} style={{ height: 50, borderRadius: 15 }}  >
  <option value="">Select Type </option>
  {
    type.map((item, index) => {
      return (

        <option key={index} value={item.statusName}>{item.statusName}</option>

      );
    }

    )
  }
</select>
</OverlayTrigger>
              <div className="invalid-feedback">{errors.type?.message}</div>
        </div>
        <div className="mt-4">
        {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Linkedin URL</Tooltip>)}>
                <input type="text" name="linkdinUrl" {...register("linkdinUrl")} placeholder="Linkedin URL" className={`form-control basic-form`}/>
              </OverlayTrigger> */}
              {/* <div className="invalid-feedback">{errors.linkdinUrl?.message}</div> */}

        </div>
         </div>
           </div>

          </div>
         
          <div className="row mt-4 p-0">
            <div className="col-12">
            <Link to="/Employer/ListofStaffingContacts"> 
             <button style={{ float: "right" }} disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                        Cancel
                      </button>
                      </Link>
              <button style={{float:"right"}} disabled={isSubmitting || isDisabled} className="btn btn-primary mr-3">
                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                Update
              </button> &nbsp;&nbsp;&nbsp;
            </div>
        </div>
        </form>
        </div></div>
                </div>
  </section>
    </ConsultantLayout>
  );
}

export default EditHotList;